import React from 'react';
import { Box } from '@mui/material';
import type { BoxProps } from '@mui/material';

export type SafeBoxProps = Omit<BoxProps, 'component'>;

// workaround for https://github.com/mui/material-ui/issues/34068
export function SafeBox(props: SafeBoxProps) {
    const { children, ...otherProps } = props;
    return <Box component='div' {...otherProps}>{children}</Box>;
}
